import inputWithOptionsDriverFactory from '../InputWithOptions/InputWithOptions.driver';

const dropdownDriverFactory = inputWithOptionsDriverFactory;

export default dropdownDriverFactory;
